import styled, { css } from 'styled-components'
import BasePublicationThumbnail from '../PublicationThumbnail'
import BaseHeartButton from '../HeartButton'
import { Text, truncateLines, Button } from '@sketch/components'
import { ReactComponent as EllipsisIcon } from '@sketch/icons/dots-3-horizontal-24'
import { breakpoint } from '@sketch/global-styles'

export const Name = styled(Text)`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: ${({ theme }) => theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};

  ${truncateLines(1)}
`

export const PublicationThumbnail = styled(BasePublicationThumbnail)`
  width: 100%;
  margin-bottom: 14px; /* stylelint-disable-line scales/space */
`

export const DropdownButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;

  opacity: 0;
  transform: translate3d(0, -5px, 0);
  transition: ${({ theme }) => `
    opacity ${theme.transitions.duration[0]} ${theme.transitions.timing.easeInOut},
    transform ${theme.transitions.duration[0]} ${theme.transitions.timing.easeInOut};
  `};
`

export const GridFocusStyles = css`
  ${DropdownButtonWrapper} {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  :hover {
    ${PublicationThumbnail} {
      box-shadow:
        0 4px 12px 0 ${({ theme }) => theme.colors.border.A},
        0 12px 40px 0 ${({ theme }) => theme.colors.border.A};
    }

    ${Name} {
      color: ${({ theme }) => theme.colors.foreground.secondary.B};
    }

    ${DropdownButtonWrapper} {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  @media (hover: none) {
    ${GridFocusStyles}
  }

  &:hover,
  &:focus,
  &:focus-within {
    ${GridFocusStyles}
  }

  /* Keep the button visible when the dropdown is open */
  [aria-expanded='true'] ${DropdownButtonWrapper} {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

export const NameSkeleton = styled(Name)`
  margin-top: 10px; /* stylelint-disable-line scales/space */
  width: 40%;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border-radius: ${({ theme }) => theme.radii.xlarge};

  ::after {
    /* Have some dummy text to fill the height */
    content: 'a';
    opacity: 0;
  }
`

export const WorkspaceProfile = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.C};
  line-height: 1.333; /* stylelint-disable-line scales/line-height */
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  white-space: break-spaces;
  margin: 0 8px;

  ${breakpoint('base', 'sm')`
    flex-direction: column;
  `}
`

export const HeartButton = styled(BaseHeartButton)`
  min-width: 64px;
  margin-left: 12px;
`

export const DropdownButton = styled(Button).attrs({
  variant: 'secondary',
  size: '32',
})`
  background-clip: padding-box;
  padding: 4px 8px;
`

export const DropdownButtonEllipsis = styled(EllipsisIcon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const Icon = styled.div<{ $isLibrary?: boolean }>`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  justify-content: space-between;
  flex-shrink: 0;

  ${({ $isLibrary, theme }) =>
    $isLibrary &&
    `
      color: ${theme.colors.inspect.symbol.A};
    `}
`

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Right = styled.div`
  flex-shrink: 0;
  align-self: center;

  ${breakpoint('base', 'sm')`
    align-self: flex-start;
  `}
`

export const UpdatedAt = styled.div`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: ${({ theme }) => theme.fontSizes.E};
  margin-left: 8px;

  ${breakpoint('base', 'sm')`
    margin-left: 0;
  `}
`
